<template>
  <a-modal v-model:visible="visible" title="水质监测中心" width="80%" :footer="null"  destroyOnClose>
    <div class="container">
      <div style="position: relative">
        <a-select v-model:value="selectedMonth" style="width: 200px;float: right">
          <a-select-option value="2025-6">2025-06</a-select-option>
          <a-select-option value="2025-5">2025-5</a-select-option>
          <a-select-option value="2025-4">2025-4</a-select-option>
          <a-select-option value="2025-3">2025-3</a-select-option>
        </a-select>
      </div>
      <div class="chart-container">
        <div ref="chart1" class="chart"></div>
        <div ref="chart2" class="chart"></div>
        <div ref="chart3" class="chart"></div>
        <div ref="chart4" class="chart"></div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import * as ECharts from "echarts";

export default {
  name: "WaterQuality",
  data() {
    return {
      visible: false,
      selectedMonth: "2025-6"
    }
  },
  mounted() {
    // 移除mounted中的init调用
  },
  methods: {
    open() {
      this.visible = true;
      // 在对话框打开后，使用nextTick确保DOM已经渲染
      this.$nextTick(() => {
        this.init();
      });
    },
    init() {
      let {dates, turbidityData, phData, doData, chlorophyllData} = this.initData();
      this.initChart("chart1", "月度浊度监测图", dates, turbidityData, "NTU");
      this.initChart("chart2", "月度pH值监测图", dates, phData, "pH");
      this.initChart("chart3", "月度溶解氧监测图", dates, doData, "mg/L");
      this.initChart("chart4", "月度叶绿素a监测图", dates, chlorophyllData, "μg/L");
    },
    initData() {
      const dates = Array.from({length: 30}, (_, i) => {
        const d = new Date();
        d.setDate(d.getDate() - (29 - i));
        return d.toISOString().split('T')[0];
      });

      const turbidityData = Array.from({length: 30}, () => +(Math.random() * 30 + 10).toFixed(2));
      const phData = Array.from({length: 30}, () => +(Math.random() * 2 + 6.5).toFixed(2));
      const doData = Array.from({length: 30}, () => +(Math.random() * 6 + 6).toFixed(2));
      const chlorophyllData = Array.from({length: 30}, () => +(Math.random() * 20 + 5).toFixed(2));
      return {dates, turbidityData, phData, doData, chlorophyllData};
    },
    initChart(id, title, dates, data, yLabel) {
      // 检查DOM元素是否存在
      if (!this.$refs[id]) {
        console.warn(`DOM element for chart ${id} not found`);
        return;
      }
      
      let chart = ECharts.init(this.$refs[id]);
      chart.setOption({
        title: {text: title, left: 'center'},
        tooltip: {trigger: 'axis'},
        xAxis: {type: 'category', data: dates},
        yAxis: {type: 'value', name: yLabel},
        series: [{
          data: data,
          type: 'line',
          smooth: true,
          areaStyle: {},
          symbol: 'circle'
        }]
      });
      
      // 添加窗口大小变化的监听，确保图表自适应
      window.addEventListener('resize', () => {
        chart.resize();
      });
    },
  },
  // 添加watch以响应选择月份变化
  watch: {
    selectedMonth: {
      handler() {
        // 当选择的月份变化时，重新初始化图表
        this.$nextTick(() => {
          this.init();
        });
      }
    },
    // 监听visible，处理对话框关闭时的清理工作
    visible(val) {
      if (!val) {
        // 对话框关闭，清理ECharts实例
        ['chart1', 'chart2', 'chart3', 'chart4'].forEach(id => {
          if (this.$refs[id] && this.$refs[id].__echarts__) {
            ECharts.dispose(this.$refs[id]);
          }
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 79vh;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 0px; // 垂直滚动条宽度
  }
}

.chart-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}

.chart {
  width: 50%;
  height: 500px;
  margin-top: 40px;
}

</style>